<style lang="scss" scoped="">

  .order-list-item {
    cursor: pointer;
  }

  .header-list {
    overflow: hidden;
  }

  .opera-btn-group {
    margin-left: 0;
    margin-right: 0;
  }
</style>
<template>
  <div class="order-page">
    <div class="container">
      <search-part ref="searchPart" @search="search"/>
      <el-table :data="batches" class="header-list store border-black" border @row-click="showDetail"
                :header-row-class-name="'headerClass'" v-loading="loadingData" :summary-method="getSummaries"
                :row-class-name="formatRowClass" @cell-mouse-enter="cellMouseEnter" @cell-mouse-leave="cellMouseLeave"
                show-summary style="width: 100%">
        <el-table-column prop="logisticsCentreName" label="物流中心" min-width="160" :sortable="true">
          <template slot-scope="scope">
            <span>{{scope.row.logisticsCompanyName}}</span>
            <span v-show="scope.row.logisticsCentreName">-{{scope.row.logisticsCentreName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orgName" label="货主" min-width="200" :sortable="true"></el-table-column>
        <el-table-column prop="goodsName" label="货品" min-width="200" :sortable="true"></el-table-column>
        <el-table-column prop="supplyManufacturersName" label="供货单位" min-width="160" :sortable="true"></el-table-column>
        <el-table-column prop="batchNumber" label="批号" :sortable="true" width="110"></el-table-column>

        <el-table-column label="业务库存" align="center">
          <el-table-column prop="availableCount" label="合格" :render-header="formatHeader" :sortable="true"
                           width="100">
            <template slot-scope="scope">
              <span>{{scope.row.availableCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="unqualifiedBizCount" label="不合格" :render-header="formatHeader" :sortable="true"
                           width="100">
            <template slot-scope="scope">
              <span>{{scope.row.unqualifiedBizCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="undeterminedCount" label="业务停销" :render-header="formatHeader" :sortable="true"
                           width="110">
            <template slot-scope="scope">
              <span>{{scope.row.undeterminedCount}}</span>
            </template>
          </el-table-column>
        </el-table-column>


        <el-table-column label="实物库存" align="center">
          <el-table-column prop="qualifiedCount" label="合格" :render-header="formatHeader" :sortable="true"
                           width="100">
            <template slot-scope="scope">
              <span>{{scope.row.qualifiedCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="unqualifiedCount" label="不合格" :render-header="formatHeader" :sortable="true"
                           width="100">
            <template slot-scope="scope">
              <span>{{scope.row.unqualifiedCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="transitCount" label="在途库存" :render-header="formatHeader" :sortable="true"
                           width="100">
            <template slot-scope="scope">
              <span>{{scope.row.transitCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalCount" label="库存总数" :render-header="formatHeader" :sortable="true"
                           width="100">
            <template slot-scope="scope">
              <span>{{scope.row.totalCount}}</span>
            </template>
          </el-table-column>
        </el-table-column>


        <el-table-column prop="expiryDate" label="有效期" :sortable="true" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.expiryDate | date}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="expiryDate" label="创建时间" :sortable="true" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="text-center" v-show="batches.length&&!loadingData">
        <el-pagination :current-page="pager.currentPage" :page-size="20"
                       :page-sizes="[20,50,100]"
                       :total="pager.count" @current-change="handleCurrentChange" @size-change="handleSizeChange"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>

    <page-right :show="showDetailPart" @right-close="resetRightBox" :css="{'width':'900px','padding':0}">
      <detail :currentItem="currentItem" @close="resetRightBox" :isPlatForm="isPlatForm"
              :isBatchNumber="isBatchNumber"></detail>
    </page-right>
  </div>
</template>
<script type="text/jsx">
  import {BspStock} from '@/resources';
  import detail from './detail.vue';
  import validMixin from '@/mixins/vaildMixin';
  import SearchPart from './search';

  export default {
    components: {detail, SearchPart},
    mixins: [validMixin],
    data() {
      return {
        loadingData: true,
        showDetailPart: false,
        filters: {
          effectiveFlag: true
        },
        batches: [],
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 20
        },
        currentItemId: '',
        currentItem: {},
        statusTitle: [
          '已过期',
          '即将到期',
          '正常'
        ],
        statusType: [
          'danger',
          'warning',
          'primary'
        ]
      };
    },
    mounted() {
      this.getBatches(1);
    },
    computed: {
      orgLevel() {
        return this.$store.state.orgLevel;
      },
      role() {
        return this.$route.meta.role;
      },
      isPlatForm() {
        return this.role === 'platform';
      },
      type() {
        return this.$route.meta.type;
      },
      isBatchNumber() {
        return this.type === 'batchNumber';
      }
    },
    watch: {
      $route() {
        this.$refs.searchPart.resetSearchForm();
      }
    },
    methods: {
      formatRowClass(data) {
        if (this.isValid(data.row) === 1) {
          return 'effective-row';
        }
        if (this.isValid(data.row) === 0) {
          return 'danger-row';
        }
      },
      isValid(item) {
        let a = this.$moment();
        let b = this.$moment(item.expiryDate);
        let days = b.diff(a, 'days');
        return a < b ? days > 90 ? 2 : 1 : 0;
      },
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.getBatches(1);
      },
      handleCurrentChange(val) {
        this.getBatches(val);
      },
      getBatches(pageNo) { // 得到波次列表
        this.pager.currentPage = pageNo;
        this.batches = [];
        let params = Object.assign({
          pageNo: pageNo,
          pageSize: this.pager.pageSize
        }, this.filters);
        if(!params.effectiveFlag) {
          delete params.effectiveFlag;
        }
        this.loadingData = true;
        let prop = '';
        if (this.isBatchNumber) {
          prop = this.isPlatForm ? 'query' : 'queryOrgStock';
        } else if (this.type === 'batch') {
          prop = this.isPlatForm ? 'queryBatchStock' : 'queryOrgBatchStock';
        } else if (this.type === 'flow') {
          prop = 'queryOrgStoreFlow';
        }
        BspStock[prop](params).then(res => {
          res.data.list.forEach(i => {
            i.totalCount = i.undeterminedCount + i.qualifiedCount + i.transitCount + i.unqualifiedCount;
          });
          this.batches = res.data.list;
          this.pager.count = res.data.count;
          this.loadingData = false;
        });
      },
      formatHeader(h, col) {
        let property = col.column.property;
        let content = '';
        let title = '';
        switch (property) {
          case 'qualifiedCount': {
            content = '仓库内真实合格货品数量';
            title = '合格';
            break;
          }
          case 'unqualifiedCount': {
            content = '仓库内真实不合格货品数量';
            title = '不合格';
            break;
          }
          case 'transitCount': {
            content = '在运输中的货品数量';
            title = '在途库存';
            break;
          }
          case 'totalCount': {
            content = '用于计算资产';
            title = '库存总数';
            break;
          }
          case 'availableCount': {
            content = '用于出库订单的控制，表明可销售的数量';
            title = '合格';
            break;
          }
          case 'unqualifiedBizCount': {
            content = '用于不合格品退货订单控制';
            title = '不合格';
            break;
          }
          case 'undeterminedCount': {
            content = '仓库内质量状态待确定而不允许销售的库存数';
            title = '业务停销';
            break;
          }
        }
        return (
          <el-tooltip effect="dark" content={content} placement="top">
            <span>{title}</span>
          </el-tooltip>
        );
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (column.property !== 'availableCount' && column.property !== 'qualifiedCount' &&
            column.property !== 'transitCount' && column.property !== 'unqualifiedCount'
            && column.property !== 'undeterminedCount' && column.property !== 'totalCount' && column.property !== 'unqualifiedBizCount') {
            sums[index] = '';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '';
          }
        });
        return sums;
      },
      showDetail(item) {
        this.currentItemId = item.id;
        this.currentItem = item;
        this.showDetailPart = true;
      },
      resetRightBox() {
        this.showDetailPart = false;
      },
      search(val) {
        Object.assign(this.filters, val);
        this.getBatches(1);
      }
    }
  };
</script>
